import isNumber from 'lodash/isNumber.js';

export const from = '1.0';
export const to = 2;

export function up(schema) {
  return {
    animation: [],
    customFonts: [],
    styles: {},
    ...schema,
    audio: migrateAudio(schema.audio),
    foreground: migrateImages(schema.foreground),
    image: migrateImages(schema.image),
    logo: migrateLogo(schema.logo),
    video: migrateVideos(schema.video),
    version: to,
  };
}

export function down(schema) {
  return {
    ...schema,
    version: from,
  };
}

export default {
  from,
  to,
  up,
  down,
};

function migrateLogo(logo = null) {
  return isNumber(logo) ? null : logo;
}

function migrateAudio(audios = []) {
  return audios.map((audio) => ({
    fadeIn: 0,
    fadeOut: 0,
    volume: 1,
    ...audio,
  }));
}

function migrateImages(images = []) {
  return images.map((image) => ({
    fadeIn: 0,
    fadeOut: 0,
    opacity: 1,
    ...image,
  }));
}

function migrateVideos(videos = []) {
  return videos.map((video) => ({
    fadeIn: 0,
    fadeOut: 0,
    opacity: 1,
    volume: 0,
    ...video,
  }));
}
